import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { register, reset } from "../features/auth/authSlice";
import { useEffect } from "react";
import { useToast } from "../components/Toast";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";

function Register() {
  const toast = useToast();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    password2: "",
  });

  const { name, email, password, password2 } = formData;
  const { user, isError, message, isLoading } = useSelector((state) => {
    return state.auth;
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  useEffect(() => {
    if (isError) {
      toast.error(message);
    }

    if (user) {
      navigate("/");
    }

    dispatch(reset());
  }, [message, isError, dispatch, user, navigate, toast]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (password !== password2) {
      toast.error("Password does not Match", { autoClose: 5000 });
    } else {
      dispatch(register({ name, email, password }));
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-[#0b0e14] py-12 px-4 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-1/4 -right-20 w-80 h-80 bg-purple-600/10 rounded-full blur-[120px] animate-pulse pointer-events-none" />
      <div className="absolute bottom-1/4 -left-20 w-80 h-80 bg-cyan-500/10 rounded-full blur-[120px] animate-pulse pointer-events-none" />

      <div className="w-full max-w-md relative z-10">
        {/* Terminal Header */}
        <div className="mb-10 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-purple-500/10 border border-purple-500/20 rounded-full text-[10px] font-black text-purple-400 uppercase tracking-[0.3em] mb-4">
            <span className="w-1.5 h-1.5 bg-purple-400 rounded-full animate-ping" />
            Recruitment Protocol
          </div>
          <h2 className="text-4xl font-black text-white uppercase italic tracking-tighter">
            Player <span className="text-purple-400">Registry</span>
          </h2>
        </div>

        {/* Register Form Card */}
        <form
          className="bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[32px] p-8 md:p-10 flex flex-col gap-6 shadow-2xl relative group"
          onSubmit={onSubmit}
        >
          {/* Cyber Accent Line */}
          <div className="absolute top-0 left-10 right-10 h-px bg-gradient-to-r from-transparent via-purple-500/50 to-transparent" />

          <div className="flex flex-col gap-5 w-full">
            <div className="space-y-1">
              <label className="text-[10px] font-black text-gray-500 uppercase tracking-widest ml-1">
                Callsign / Name
              </label>
              <input
                type="text"
                name="name"
                id="name"
                className="w-full p-4 bg-white/5 border border-white/10 rounded-2xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-purple-500/40 transition-all font-medium"
                value={name}
                placeholder="PLAYER_NAME"
                autoComplete="off"
                onChange={onChange}
              />
            </div>

            <div className="space-y-1">
              <label className="text-[10px] font-black text-gray-500 uppercase tracking-widest ml-1">
                Comm Frequency (Email)
              </label>
              <input
                type="email"
                name="email"
                id="email"
                className="w-full p-4 bg-white/5 border border-white/10 rounded-2xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-cyan-500/40 transition-all font-medium"
                value={email}
                placeholder="RECRUIT_EMAIL"
                autoComplete="off"
                onChange={onChange}
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1">
                <label className="text-[10px] font-black text-gray-500 uppercase tracking-widest ml-1">
                  Access Key
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  className="w-full p-4 bg-white/5 border border-white/10 rounded-2xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-purple-500/40 transition-all font-medium"
                  value={password}
                  placeholder="••••••••"
                  autoComplete="off"
                  onChange={onChange}
                />
              </div>
              <div className="space-y-1">
                <label className="text-[10px] font-black text-gray-500 uppercase tracking-widest ml-1">
                  Verify Key
                </label>
                <input
                  type="password"
                  name="password2"
                  id="password2"
                  className="w-full p-4 bg-white/5 border border-white/10 rounded-2xl text-white placeholder:text-gray-600 focus:outline-none focus:ring-2 focus:ring-purple-500/40 transition-all font-medium"
                  value={password2}
                  placeholder="••••••••"
                  autoComplete="off"
                  onChange={onChange}
                />
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="group relative w-full p-4 bg-gradient-to-r from-purple-600 to-cyan-500 rounded-2xl text-white font-black uppercase tracking-widest text-sm hover:from-purple-500 hover:to-cyan-400 transition-all duration-300 shadow-lg shadow-purple-500/20 active:scale-[0.98] disabled:opacity-50 overflow-hidden"
            disabled={isLoading}
          >
            <div className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500" />
            <span className="relative flex justify-center items-center gap-2">
              {isLoading ? <Loader size="sm" /> : "Deploy Agent"}
            </span>
          </button>

          <div className="mt-4 pt-6 border-t border-white/5 flex flex-col items-center gap-4 text-[11px]">
            <div className="flex items-center gap-2 text-gray-500 font-bold uppercase tracking-wider">
              <span>Already Recruited?</span>
              <Link
                to="/login"
                className="text-purple-400 hover:text-purple-300 transition-colors underline decoration-purple-500/30 underline-offset-4"
              >
                Access Terminal
              </Link>
            </div>

            <div className="flex items-center gap-2 px-3 py-2 bg-white/5 rounded-xl border border-white/5">
              <span className="text-amber-500 animate-pulse">✨</span>
              <p className="text-[9px] text-gray-400 font-bold uppercase tracking-widest leading-none">
                Recruitment Bonus:{" "}
                <span className="text-white">50 Gamer Pts</span>
              </p>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;
